
async function getPage(post) {
    const response = await fetch( `/data/posts/${post}`);
    const body = await response.text();

    return body;
};

export default getPage;